export const OPEN_SIGNUP_DRAWER = 'OPEN_SIGNUP_DRAWER';
export const CLOSE_SIGNUP_DRAWER = 'CLOSE_SIGNUP_DRAWER';
export const OPEN_SIGNIN_DRAWER = 'OPEN_SIGNIN_DRAWER';
export const CLOSE_SIGNIN_DRAWER = 'CLOSE_SIGNIN_DRAWER';
export const OPEN_FORGOT_PASSWORD_DRAWER = 'OPEN_FORGOT_PASSWORD_DRAWER';
export const CLOSE_FORGOT_PASSWORD_DRAWER = 'CLOSE_FORGOT_PASSWORD_DRAWER';
export const OPEN_DASHBOARD_DRAWER = 'OPEN_DASHBOARD_DRAWER';
export const CLOSE_DASHBOARD_DRAWER = 'CLOSE_DASHBOARD_DRAWER';
export const OPEN_NAVIGATION_DRAWER = 'OPEN_NAVIGATION_DRAWER';
export const CLOSE_NAVIGATION_DRAWER = 'CLOSE_NAVIGATION_DRAWER';



// WEBPACK FOOTER //
// ./src/features/Layout/types.js